import React from 'react'
import { TiDocumentText } from "react-icons/ti";
import { LiaHandshakeSolid } from "react-icons/lia";
import { GiInjustice } from "react-icons/gi";
import { GrHome } from "react-icons/gr";
import { PiPhoneThin } from "react-icons/pi";
import { PiComputerTowerThin } from "react-icons/pi";
import {motion} from "framer-motion"
import { GiAutoRepair } from "react-icons/gi";
import { IoMdKey } from "react-icons/io";
import { MdOutlineRecycling } from "react-icons/md";
import { CiWarning } from "react-icons/ci";
import { GiPlantWatering } from "react-icons/gi";
import { MdSecurity } from "react-icons/md";

const FeaturesSection = ({item}) => {
  const iconMap = {
    TiDocumentText: TiDocumentText,
    GrHome: GrHome,
    LiaHandshakeSolid:LiaHandshakeSolid,
    PiPhoneThin:PiPhoneThin,
    GiInjustice:GiInjustice,
    PiComputerTowerThin:PiComputerTowerThin,
    GiAutoRepair:GiAutoRepair,
    IoMdKey:IoMdKey,
    MdOutlineRecycling:MdOutlineRecycling,
    CiWarning:CiWarning,
    GiPlantWatering:GiPlantWatering,
    MdSecurity:MdSecurity
  };

  const IconComponent = iconMap[item.icon] || TiDocumentText
  return (
    <>
    
        <motion.div 
         initial={{ opacity: 0,x:-50 }}
         whileInView={{ opacity: 1,x:0 }}
         transition={{ duration: 1, ease: 'easeOut' }}
         viewport={{ once: true, amount: 0.3 }} 
         className="features">
            <div className="features-icon">
                <IconComponent/>
            </div>
            <div className="features-title">
                <h2>{item.title}</h2>
            </div>
            <div className="features-content">
                <p>
                  {item.content}
                </p>
            </div>
        </motion.div>
    </>
  )
}

export default FeaturesSection